export function TeamTasksSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/team-tasks.svg'"></ng-include>`
    }
}